import "./TwoColumnList.css";

// Generates a row with Key: Value - so we can make nice looking lists

const TwoColumnList = ({ property, value, valueIsToggle = false, valueIsNumberStepper = false }) => {

    return (

        <div className="two-column-list__row">

            <div className="two-column-list__key">
                
                {property}
                
            </div>

            <div className={`two-column-list__value ${valueIsToggle ? "two-column-list__toggle" : ""} ${valueIsNumberStepper ? "two-column-list__number-stepper" : ""}`} >
                
                {value}
                
            </div>

        </div>

    );

};

export default TwoColumnList;